import PageContent from './PageContent';

export default PageContent;



// WEBPACK FOOTER //
// ./src/components/Page/PageContent/index.tsx